var _defs, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSimulados(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Logo",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1920 1080",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-3{fill:#1373a9;}.cls-2{fill:#ebb91d;}.cls-2,.cls-3,.cls-4{fill-rule:evenodd;}.cls-4,.cls-6{fill:#fff;}.cls-5{fill:#043e7d;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "texto"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path28208",
    className: "cls-1",
    d: "M1871.5,698.2l-24,67.19c-72.11-39.52-132.19-3.95-60.09,31.62,40.06,11.85,64.1,27.66,80.12,43.47,20,31.62,0,98.81-48.07,114.62-36.05,15.8-96.14,0-160.24-19.77l28-67.18c64.1,39.52,104.16,47.42,124.19,19.76,8-15.81-12-27.67-40.06-31.62C1643.16,820.72,1623.13,646.82,1871.5,698.2Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "logo_oi"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path28200",
    className: "cls-2",
    d: "M1523,650.77c84.13,0,152.23,71.14,152.23,154.14S1607.11,955.1,1523,955.1c-88.13,0-156.23-67.19-156.23-150.19S1434.85,650.77,1523,650.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path28202",
    className: "cls-3",
    d: "M1523,706.11h0c8,0,12,7.9,12,15.8V801c0,7.9-4,15.81-12,15.81h0c-8,0-16-7.91-16-15.81V721.91C1507,714,1515,706.11,1523,706.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path28204",
    className: "cls-3",
    d: "M1523,666.58c8,0,12,7.91,12,15.81s-4,11.86-12,11.86-16-4-16-11.86S1515,666.58,1523,666.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path28206",
    className: "cls-4",
    d: "M1571.05,721.91c28,15.81,48.07,43.48,48.07,79.05,0,55.33-44.06,94.85-96.14,94.85-56.08,0-100.15-39.52-100.15-94.85,0-31.62,16-63.24,44.07-79.05,20-11.85,28,11.86,16,23.72-20,11.85-32,31.62-32,55.33,0,39.52,32,67.19,72.1,67.19,36,0,68.1-27.67,68.1-67.19,0-23.71-12-43.48-32-55.33C1543,733.77,1555,714,1571.05,721.91Z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "path28222",
    className: "cls-3",
    d: "M1186.48,635c244.37,55.33,220.33,264.79,8,320.13Zm64.1,102.75c60.09,23.72,68.1,79,4,98.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path28220",
    className: "cls-3",
    d: "M958.15,777.25c20-63.24,56.08-98.81,116.17-94.86,72.11,4,100.15,43.48,104.15,130.43V947.19l-64.09,3.95-4-7.9c-180.26,4-160.23-177.85-4-126.47,4-43.48-4-67.19-24-67.19-24-4-44.06,7.9-56.08,39.52Zm152.22,75.09v47.42C1018.24,880,1034.26,840.48,1110.37,852.34Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "polygon28218",
    className: "cls-3",
    points: "886.04 951.14 874.02 634.97 934.11 634.97 958.15 943.24 886.04 951.14"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path28216",
    className: "cls-3",
    d: "M685.75,678.44l64.09-4c-4,63.23-12,134.37,8,189.7,8,27.67,24,19.77,52.08-19.76v-162H870l-12,264.8H817.94V923.48C753.85,967,717.79,959.05,701.77,911.62,685.75,844.43,685.75,761.44,685.75,678.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path28214",
    className: "cls-3",
    d: "M365.27,710.06l60.09-11.86,4,31.62c44.06-47.43,84.12-43.48,116.17,19.76,24-47.43,88.13-55.33,116.17,0,16,67.19,16,134.38,8,201.56H617.65c4-102.75-4-166-32-166-24,4-32.05,63.24-24,170H505.48c4-110.67-4-173.9-32.05-173.9-20,11.85-32,27.66-40.06,47.42V963H377.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path28210",
    className: "cls-3",
    d: "M281.15,781.2l76.11-7.91-12,185.76-64.09,4C289.16,903.72,285.15,840.48,281.15,781.2Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "circle28212",
    className: "cls-1",
    cx: 317.2,
    cy: 706.11,
    rx: 40.06,
    ry: 39.52
  }), /*#__PURE__*/React.createElement("path", {
    id: "path28226",
    className: "cls-5",
    d: "M257.11,698.2l-20,67.19C161,725.87,100.88,761.44,177,797c36.06,11.85,64.1,27.66,76.12,43.47,20,31.62,0,98.81-48.07,114.62-32,15.8-92.14,0-160.24-19.77l32.05-67.18C136.94,907.67,181,915.57,197,887.91c8-15.81-8-27.67-36.05-31.62C28.78,820.72,8.75,646.82,257.11,698.2Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "boneco"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "circle28230",
    className: "cls-5",
    cx: 960,
    cy: 354.36,
    rx: 240.35,
    ry: 237.13
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "circle28232",
    className: "cls-6",
    cx: 964.01,
    cy: 287.17,
    rx: 104.15,
    ry: 102.76
  }), /*#__PURE__*/React.createElement("path", {
    id: "path28234",
    className: "cls-4",
    d: "M867.86,370.17c60.09,59.28,124.19,63.23,192.29,3.95,44.06,3.95,64.09,47.43,72.1,98.8-88.13,114.62-256.37,114.62-340.5,0C803.77,417.59,823.8,378.07,867.86,370.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path28236",
    className: "cls-5",
    d: "M980,322.74H948v-7.9c0-15.81,4-23.72,12-31.62a21.7,21.7,0,0,0,12-19.76c0-11.86-4-15.81-12-15.81-12,0-20,3.95-32,15.81l-12-39.53c16-4,36.06-4,48.08-4,24,0,36,7.91,40.06,19.76,4,7.91,4,15.81,4,19.76,0,15.81-4,23.72-12,31.62-12,3.95-16,15.81-16,23.72Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "circle28238",
    className: "cls-5",
    cx: 960,
    cy: 354.36,
    rx: 20.03,
    ry: 19.76
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSimulados);
export default __webpack_public_path__ + "static/media/simulados.33eb3c0ae36b36bcb0c8bd54274d5323.svg";
export { ForwardRef as ReactComponent };